import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import type { TimeRange } from "@@/shared/date-time/time-range";
import type { OrderId } from "@@/shared/orders/order-id";
import type { Except } from "type-fest";
import type { ResourceReservation } from "../resources/resource-reservation";
import type { ReservationId} from "./reservation-id";
import { reservationIdFactory } from "./reservation-id";

type ReservationSimplified = {
    readonly _id: ReservationId;
    readonly _type: "RESERVATION_SIMPLE";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly timeRange: TimeRange;
    readonly orderId?: OrderId;
    readonly mainQuantity: number;
    readonly resourceReservations: ResourceReservation[];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isReservationSimplified = (item: any): item is ReservationSimplified => {
    return item._type === "RESERVATION_SIMPLE";
};

type CreateParams = Except<ReservationSimplified, "_type" | "_id">;
const createReservationSimplified = (
    params: CreateParams,
): ReservationSimplified => {
    return {
        ...params,
        _type: "RESERVATION_SIMPLE",
        _id: reservationIdFactory(),
    };
};
export { createReservationSimplified, isReservationSimplified };
export type { ReservationSimplified };
